import { apiFetch } from './api';

export type DomainStatus = 'pending' | 'verified' | 'failed' | 'temporary_failure';

export interface DomainDnsRecord {
  type: 'TXT' | 'MX' | 'CNAME';
  name: string;
  value: string;
  priority?: number;
  ttl?: number;
  label: string;
  purpose: 'verification' | 'spf' | 'dkim' | 'dmarc' | 'mx' | 'other';
}

export interface SendingDomain {
  id: string;
  domain: string;
  status: DomainStatus;
  dnsRecords: DomainDnsRecord[];
  lastCheckedAt: number | null;
  verifiedAt: number | null;
  createdAt: number;
}

export async function listDomains(): Promise<SendingDomain[]> {
  const data = await apiFetch<{ domains: SendingDomain[] }>('/api/domains');
  return data.domains;
}

export async function createDomain(domain: string): Promise<SendingDomain> {
  const data = await apiFetch<{ domain: SendingDomain }>('/api/domains', {
    method: 'POST',
    json: { domain },
  });
  return data.domain;
}

export async function verifyDomain(id: string): Promise<SendingDomain> {
  const data = await apiFetch<{ domain: SendingDomain }>(`/api/domains/${id}/verify`, {
    method: 'POST',
  });
  return data.domain;
}

export async function deleteDomain(id: string): Promise<void> {
  await apiFetch<{ ok: true }>(`/api/domains/${id}`, { method: 'DELETE' });
}

export const STATUS_LABEL: Record<DomainStatus, string> = {
  pending: 'Pending DNS',
  verified: 'Verified',
  failed: 'Verification failed',
  temporary_failure: 'Temporarily failed',
};
